export class WebhookV1StandardPayloadBackupJobPartial {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "WebhookV1StandardPayloadBackupJobPartialTypeEnum",
            "format": ""
        },
        {
            "name": "arguments",
            "baseName": "arguments",
            "type": "WebhookV1StandardPayloadBackupJobPartialArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadBackupJobPartial.attributeTypeMap;
    }
    constructor() {
    }
}
export var WebhookV1StandardPayloadBackupJobPartialTypeEnum;
(function (WebhookV1StandardPayloadBackupJobPartialTypeEnum) {
    WebhookV1StandardPayloadBackupJobPartialTypeEnum["BackupJobPartial"] = "BACKUP_JOB_PARTIAL";
})(WebhookV1StandardPayloadBackupJobPartialTypeEnum || (WebhookV1StandardPayloadBackupJobPartialTypeEnum = {}));
